import Categories from './categories.js';
import Tags from './tags.js';

/**
 * Creates instances of the Categories and Tags classes, which listen
 * to the changes in both metaboxes to save the values using AJAX.
 * We need to do this because Automator doesn't have a "Save" button.
 */
export default class Taxonomies {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		// Invoke class used to save the categories using AJAX
		new Categories();

		// Invoke class used to save the tags using AJAX
		new Tags();
	}
}
